import * as React from 'react';
import { Link } from 'gatsby';
import Image from 'gatsby-image';
import { Tag, PostAuthor, ImageFluid } from '../Types';
import clsx from 'clsx';
import styles from './item.module.css';
import Person from 'components/person';
import Tags from '../tags';

interface Props {
  img: ImageFluid;
  title: string;
  date: string;
  tags: ReadonlyArray<Tag>;
  author: PostAuthor;
  path: string;
  slug: string;
}

function Item({ path, title, img, date, tags, author, slug }: Props) {
  const to = `${path}${slug}/`;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.top}>
          <div className={styles.date}>{date}</div>
          <Link to={to} className={styles.linkWrapper}>
            <h2 className={styles.title}>{title}</h2>
          </Link>
        </div>
        <Link to={to} className={clsx(styles.imgWrapper)}>
          <Image fluid={img} alt={title} className={styles.img} />
        </Link>
        <Tags list={tags} className={styles.tags} />
        <Person
          customClass={styles.person}
          title={author.title}
          name={author.name}
          ava={author?.photo?.childImageSharp?.fluid}
        />
        <Link to={to} className={styles.link}>
          Read post
        </Link>
      </div>
    </div>
  );
}

export default Item;
